import { User, createUnblockUserMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type UnblockUserModel = ConfirmModalModel<User, number, null>;

export const createUnblockUserModel = (): UnblockUserModel => {
	const unblockUserMutation = createUnblockUserMutation();

	const model = createConfirmModalModel<User, number, null>({
		modalData: declareModalData<User>(),
		mapModalData: ({ id }) => id,
		mutation: unblockUserMutation,
		successMessageKey: 'unblock-user.success',
	});

	return model;
};
